import React from "react";

import {
  Flex,
  FlexProps,
  Link,
  Span,
  StarRating,
} from "@catchoftheday/cg-components";
import { theme } from "@catchoftheday/theme";
import { minusOnePx, useMedia } from "@catchoftheday/utilities";

type ProductCardRatingProps = {
  productId: string;
  rating: number;
  ratingCount: number;
  url: string;
} & FlexProps;

export const ProductCardRating = ({
  productId,
  rating,
  ratingCount,
  url,
  ...props
}: ProductCardRatingProps) => {
  const isMobile = useMedia<boolean>(
    [`(max-width: ${minusOnePx(theme.breakpoints.md, true)})`],
    [true]
  );
  if (rating) {
    return (
      <Flex {...props}>
        <Link
          display={{ md: "inherit" }}
          m={{ sm: "8px 0 6px", md: "3px 0 6px" }}
          lineHeight={1}
          className={"js-product-link js-dnt"}
          href={`${url}#review-section`}
        >
          <StarRating
            width={isMobile ? 70 : 90}
            backgroundColour="#fff"
            rating={rating}
          />
          <Span
            fontSize={"12px"}
            ml={"6px"}
            lineHeight={{ xs: 2, md: 3 }}
            textAlign="center"
            color="typography.subText"
          >{`(${ratingCount})`}</Span>
        </Link>
      </Flex>
    );
  }

  return null;
};
